<template>
  <a class="phoneLink" @click="call">
    <i class="fa fa-phone"></i> {{ headerNumber }}
  </a>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    location: {
      required: true
    }
  },
  computed: {
    ...mapState(["headerNumber", "headerNumberLink"])
  },

  methods: {
    call() {
      const eventName = "PhoneCall";
      const eventParameters = {
        location: this.location
      };
      // Do tracking
      fbq("trackCustom", eventName, eventParameters);
      gtag("event", eventName, eventParameters);
      gtag("event", "conversion", {
        send_to: "AW-879819493/Q5oYCPn3gYMBEOX1w6MD"
      });

      // Open phone link
      window.location = this.headerNumberLink;
    }
  }
};
</script>

<style scoped>
a {
  cursor: pointer;
}
</style>
